export const SET_ERROR_MESSAGE = 'ui/set_error_message';
export const CLEAR_ERROR_MESSAGE = 'ui/clear_error_message';

export const FETCHING_START = 'ui/fetching_start';
export const FETCHING_END = 'ui/fetching_end';
